import React from 'react'
import { Svg } from '../../application'
import moment from 'moment'
import styled from 'react-emotion'
import { colors } from '../../styles'
import getText from '../strings'

const Countdown = styled('span')`
  background-color: ${props => props.holidayIsOver ? colors.tui_light_red : colors.tui_blue_25};
  color: ${props => props.holidayIsOver ? colors.tui_red : colors.tui_dark_blue};
  padding: 5px;
  border-radius: 2px;
  display: inline-flex;
  svg {
    margin-right: 5px;
  }
`

const getCountdownData = (endDate, startDate) => {
  const daysUntilHoliday = moment(startDate).diff(moment(), 'days') + 1
  const daysUntilHolidayEnds = moment(endDate || startDate).diff(moment(), 'days')

  const upcomingHoliday = daysUntilHoliday > 0
  const onHoliday = daysUntilHoliday <= 0 && daysUntilHolidayEnds >= 0
  const holidayIsOver = daysUntilHolidayEnds <= 0

  if (upcomingHoliday) {
    return {
      text: getText('time', 'daysLeft').replace('{0}', daysUntilHoliday)
    }
  }

  if (onHoliday) {
    return {
      text: getText('time', 'ongoing')
    }
  }

  if (holidayIsOver) {
    return {
      text: getText('time', 'daysSince').replace('{0}', -daysUntilHolidayEnds),
      holidayIsOver: true
    }
  }

  return { holidayIsOver: false }
}

export default ({ endDate, startDate }) => {
  const data = getCountdownData(endDate, startDate)

  return (
    <Countdown holidayIsOver={data.holidayIsOver}>
      <Svg icon="clock" />
      {data.text}
    </Countdown>
  )
}